import { apiClient } from '../client/apiClient';
import type {
	IBaseResponse,
	IPaginatedResponse,
	IPagination,
} from '../types/common';
import type { IConversation } from '../types/conversation';
import type { ITag } from '../types/tag';
import type { IUser } from '../types/user';

export const tagService = {
	/**
	 * Get popular tags
	 */
	getPopularTags: (params: IPagination) =>
		apiClient.get<IPaginatedResponse<ITag>>('/tags/popular', { params }),

	/**
	 * Get tag information
	 */
	getTagInfo: (tag: string) =>
		apiClient.get<IBaseResponse<ITag>>(`/tags/${tag}/info`),

	/**
	 * Get tag followers
	 */
	getTagFollowers: (tag: string, params: IPagination) =>
		apiClient.get<IPaginatedResponse<IUser>>(`/tags/${tag}/followers`, {
			params,
		}),

	/**
	 * Get conversations by tag
	 */
	getTagConversations: (tag: string, params: IPagination) =>
		apiClient.get<IPaginatedResponse<IConversation>>(
			`/tags/${tag}/conversations`,
			{ params },
		),

	/**
	 * Follow tag
	 */
	followTag: (tag: string) =>
		apiClient.post<IBaseResponse<{ count: number }>>(`/tags/${tag}/follow`),

	/**
	 * Unfollow tag
	 */
	unfollowTag: (tag: string) =>
		apiClient.post<IBaseResponse<{ count: number }>>(`/tags/${tag}/unfollow`),

	/**
	 * Report tag
	 */
	reportTag: (tag: string, reasons: string[]) =>
		apiClient.post<IBaseResponse<void>>(`/tags/${tag}/report`, { reasons }),
};
